<template>
  <div class="ra_content">
    <div class="ra_head">
      <div class="ra_back" @click="getBack()">返回</div>
      <div class="ra_title">
        <span
          :class="{ active: !applyStatus }"
          @click="(applyStatus = false), applyOnRefresh()"
          >招聘管理</span
        >
        /
        <span
          :class="{ active: applyStatus }"
          @click="(applyStatus = true), applyOnRefresh()"
          >外包任务管理</span
        >
      </div>
    </div>

    <div class="ra_table">
      <el-table
        :data="
          applyList.filter(
            (data) =>
              !search || data.Title.toLowerCase().includes(search.toLowerCase())
          )
        "
        style="width: 100%"
        @row-click="queryRecruit"
      >
        <el-table-column
          label="职位/岗位"
          prop="Title"
          min-width="50"
          max-width="150"
        ></el-table-column>
        <el-table-column align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="mini"
              placeholder="查询相关职位/岗位"
            />
          </template>
          <template slot-scope="scope">
            <div v-if="Status == 0">
              <el-button
                type="danger"
                round
                @click.stop="deleteRecruit(scope.row.ID)"
                >删除</el-button
              >
              <el-button
                round
                @click.stop="updateRecruit(scope.row.ID, 2)"
                v-if="scope.row.Status == 3"
                >撤回</el-button
              >
              <el-button
                round
                @click.stop="editRecruit(scope.row)"
                v-else-if="
                  scope.row.Status == 2 ||
                  scope.row.Status == 4 ||
                  scope.row.Status == 5
                "
                >编辑</el-button
              >
              <el-button
                round
                @click.stop="updateRecruit(scope.row.ID, 5)"
                v-else-if="scope.row.Status == 1"
                >下架</el-button
              >
              <span :class="scope.row.Status | filterStatusColor">{{
                scope.row.Status | filterStatusText
              }}</span>
            </div>
            <div v-else-if="Status == 1 && scope.row.Uid != Uid">
              <el-button
                type="danger"
                round
                @click.stop="deleteRecruit(scope.row.ID)"
                >删除</el-button
              >
              <el-button
                round
                @click.stop="editRecruit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="success"
                round
                @click.stop="updateRecruit(scope.row.ID, 1)"
                >通过</el-button
              >
              <el-button round @click.stop="updateRecruit(scope.row.ID, 4)"
                >不通过</el-button
              >
            </div>
            <div
              v-else-if="
                Status == 1 && scope.row.Uid == Uid && scope.row.Status != 3
              "
            >
              <el-button
                type="danger"
                round
                @click.stop="deleteRecruit(scope.row.ID)"
                >删除</el-button
              >
              <el-button
                round
                @click.stop="updateRecruit(scope.row.ID, 2)"
                v-if="scope.row.Status == 3"
                >撤回</el-button
              >
              <el-button
                round
                @click.stop="editRecruit(scope.row)"
                v-else-if="
                  scope.row.Status == 2 ||
                  scope.row.Status == 4 ||
                  scope.row.Status == 5
                "
                >编辑</el-button
              >
              <el-button
                round
                @click.stop="updateRecruit(scope.row.ID, 5)"
                v-else-if="scope.row.Status == 1"
                >下架</el-button
              >
              <span :class="scope.row.Status | filterStatusColor">{{
                scope.row.Status | filterStatusText
              }}</span>
            </div>
            <div
              v-else-if="
                Status == 1 && scope.row.Uid == Uid && scope.row.Status == 3
              "
            >
              <el-button
                type="success"
                round
                @click.stop="updateRecruit(scope.row.ID, 1)"
                >通过</el-button
              >
              <el-button round @click.stop="updateRecruit(scope.row.ID, 4)"
                >不通过</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="10"
        :pager-count="5"
        layout="prev, pager, next"
        :total="total"
        style="margin: 48px -24px 0 0 -24px"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getJobList,
  getJobDelete,
  getJobUpdate,
  getTempList,
  getTempDelete,
  getTempUpdate,
} from "@/config/api.js";
import Vue from "vue";
import { PullRefresh, List } from "vant";
import {
  Table,
  TableColumn,
  Input,
  Button,
  Pagination,
  Message,
} from "element-ui";
Vue.use(PullRefresh, List)
  .use(Table)
  .use(TableColumn)
  .use(Input)
  .use(Button)
  .use(Pagination);
Vue.prototype.$message = Message;
export default {
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      applyStatus: false,
      // 申请信息
      applyList: [],
      page: 1,
      total: 0,

      Uid: "", // uid
      Status: 0, // 角色

      search: "", // 查询
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.refresh === "1") {
        vm.applyOnRefresh();
      }
    });
  },
  beforeMount() {
    var that = this;

    if (that.$route.path == "/apply") {
      // 读取github信息
      const savedString = localStorage.getItem("github");
      if (savedString != "" && savedString != null) {
        that.githubInfo = JSON.parse(savedString);
        that.Uid = that.githubInfo.uid;
        that.Status = that.githubInfo.status;
      } else if (savedString == "" || savedString == null) {
        that.$message({
          message: "请先登录Github",
          type: "warning",
          duration: 3000,
        });

        that.$router.push({
          path: "/",
        });
      }
    }
  },
  methods: {
    // 返回上一页
    getBack() {
      var that = this;
      // that.$router.go(-1);
      that.$router.push({
        path: "/",
        query: { refresh: "1" },
      });
    },
    // 下拉刷新
    applyOnRefresh() {
      var that = this;
      that.page = 1;
      that.applyList = [];
      if (!that.applyStatus) {
        that.requestGetApplyList();
      } else {
        that.requestGetApplyListTemp();
      }
    },
    // 申请列表
    requestGetApplyList() {
      var that = this;
      var params = {
        limit: 10,
        page: that.page,
        Uid: that.Uid,
        Status: that.Status == 1 ? 3 : "",
      };
      getJobList(params).then((res) => {
        if (res.data) {
          that.applyList = res.data.data;
          that.total = res.data.total;
        }
      });
    },
    // 申请列表（外包）
    requestGetApplyListTemp() {
      var that = this;
      var params = {
        limit: 10,
        page: that.page,
        Uid: that.Uid,
        Status: that.Status == 1 ? 3 : "",
      };
      getTempList(params).then((res) => {
        if (res.data) {
          that.applyList = res.data.data;
          that.total = res.data.total;
        }
      });
    },
    // 查询招聘信息详情
    queryRecruit(row) {
      var that = this;
      if (!that.applyStatus) {
        that.$router.push({
          path: "/post",
          query: {
            article: row.Slug,
            editDisabled: row.Status,
          },
        });
      } else {
        that.$router.push({
          path: "/tempPost",
          query: {
            article: row.Slug,
            editDisabled: row.Status,
          },
        });
      }
    },
    // 编辑招聘信息详情
    editRecruit(row) {
      var that = this;
      if (!that.applyStatus) {
        that.$router.push({
          path: "/post",
          query: {
            article: row.Slug,
            editDisabled: row.Status,
          },
        });
      } else {
        that.$router.push({
          path: "/tempPost",
          query: {
            article: row.Slug,
            editDisabled: row.Status,
          },
        });
      }
    },
    // 取消招聘信息
    updateRecruit(id, status) {
      var that = this;
      var params = {
        ID: id,
        Uid: that.Uid,
        Status: status,
      };
      if (!that.applyStatus) {
        getJobUpdate(JSON.stringify(params)).then((res) => {
          if (res.data) {
            that.page = 1;
            that.applyList = [];
            that.requestGetApplyList();
          }
        });
      } else {
        // 取消招聘信息（外包）
        getTempUpdate(JSON.stringify(params)).then((res) => {
          if (res.data) {
            that.page = 1;
            that.applyList = [];
            that.requestGetApplyListTemp();
          }
        });
      }
    },
    // 删除招聘信息
    deleteRecruit(id) {
      var that = this;
      var params = {
        ID: id,
        Uid: that.Uid,
      };
      if (!that.applyStatus) {
        getJobDelete(JSON.stringify(params)).then((res) => {
          if (res.data) {
            that.page = 1;
            that.applyList = [];
            that.requestGetApplyListTemp();
          }
        });
      } else {
        // 删除招聘信息（外包）
        getTempDelete(JSON.stringify(params)).then((res) => {
          if (res.data) {
            that.page = 1;
            that.applyList = [];
            that.requestGetApplyListTemp();
          }
        });
      }
    },
    handleCurrentChange(val) {
      var that = this;
      that.page = val;
      that.applyList = [];
      if (!that.applyStatus) {
        that.requestGetApplyList();
      } else {
        that.requestGetApplyListTemp();
      }
    },
    handleSizeChange() {},
  },
  filters: {
    // 0 删除 1 审核通过 2 取消审核 3 提交审核 4 审核未通过 5 下架
    filterStatusText(val) {
      if (val != undefined && val != null && val != "") {
        if (val == 1) {
          return "审核通过";
        } else if (val == 2) {
          return "已取消";
        } else if (val == 3) {
          return "审核中";
        } else if (val == 4) {
          return "未通过";
        } else if (val == 5) {
          return "已下架";
        }
      }
    },
    // 0 删除 1 审核通过 2 取消审核 3 提交审核 4 审核未通过 5 下架
    filterStatusColor(val) {
      if (val != undefined && val != null && val != "") {
        if (val == 1) {
          return "ra_status_success";
        } else if (val == 2) {
          return "ra_status_cancel";
        } else if (val == 3) {
          return "ra_status_loading";
        } else if (val == 4) {
          return "ra_status_fail";
        } else if (val == 5) {
          return "ra_status_fail";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ra_content {
  width: 100%;
  height: calc(100%);
  min-height: 100vh;
  background: #f2f4f6;
  padding: 60px 18.75% 150px 18.75%;

  .ra_head {
    margin: 68px 0 0 0;
    width: calc(100% - 80px);
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .ra_back {
      width: 80px;
      height: 40px;
      border-radius: 20px 20px 20px 20px;
      border: 1px solid #000000;

      font-family: 2, 20;
      font-weight: normal;
      font-size: 16px;
      color: #000000;
      line-height: 38px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }

    .ra_title {
      width: calc(100% - 80px);
      height: 40px;
      font-family: 2, 20;
      font-weight: 500;
      font-size: 22px;
      color: #000000;
      line-height: 40px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }

    .active {
      font-size: 26px;
      font-weight: bold;
    }
  }

  .ra_table {
    margin: 43px 0 0 0;
    padding: 24px;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    background: #ffffff;

    .ra_status_success {
      width: 80px;
      font-family: 2, 20;
      font-weight: normal;
      font-size: 16px;
      color: #1c8c2e;
      text-align: right;
      font-style: normal;
      text-transform: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      display: inline-flex;
      justify-content: flex-end;

      margin: 0 0 0 10px;
    }

    .ra_status_cancel {
      width: 80px;
      font-family: 2, 20;
      font-weight: normal;
      font-size: 16px;
      color: #858585;
      text-align: right;
      font-style: normal;
      text-transform: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      display: inline-flex;
      justify-content: flex-end;

      margin: 0 0 0 10px;
    }

    .ra_status_loading {
      width: 80px;
      font-family: 2, 20;
      font-weight: normal;
      font-size: 16px;
      color: #000000;
      text-align: right;
      font-style: normal;
      text-transform: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      display: inline-flex;
      justify-content: flex-end;

      margin: 0 0 0 10px;
    }

    .ra_status_fail {
      width: 80px;
      font-family: 2, 20;
      font-weight: normal;
      font-size: 16px;
      color: #858585;
      text-align: right;
      font-style: normal;
      text-transform: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      display: inline-flex;
      justify-content: flex-end;

      margin: 0 0 0 10px;
    }
  }
}

@media screen and (max-width: 958px) {
  .ra_content {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    background: #f2f4f6;
    padding: 60px 4.6875% 0 4.6875%;

    .ra_head {
      margin: 44px 0 0 0;
      width: calc(100%);
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .ra_back {
        width: 80px;
        height: 40px;
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #000000;

        font-family: 2, 20;
        font-weight: normal;
        font-size: 16px;
        color: #000000;
        line-height: 38px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }

      .ra_title {
        width: calc(100% - 80px);
        height: 40px;
        font-family: 2, 20;
        font-weight: 500;
        font-size: 22px;
        color: #000000;
        line-height: 40px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }

      .active {
        font-size: 26px;
        font-weight: bold;
      }
    }

    .ra_table {
      margin: 43px 0 0 0;
      padding: 24px;
      border: 1px solid #ebebeb;
      border-radius: 3px;
      background: #ffffff;

      .ra_status_success {
        width: 80px;
        font-family: 2, 20;
        font-weight: normal;
        font-size: 16px;
        color: #1c8c2e;
        text-align: right;
        font-style: normal;
        text-transform: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        display: inline-flex;
        justify-content: flex-end;

        margin: 0 0 0 10px;
      }

      .ra_status_cancel {
        width: 80px;
        font-family: 2, 20;
        font-weight: normal;
        font-size: 16px;
        color: #858585;
        text-align: right;
        font-style: normal;
        text-transform: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        display: inline-flex;
        justify-content: flex-end;

        margin: 0 0 0 10px;
      }

      .ra_status_loading {
        width: 80px;
        font-family: 2, 20;
        font-weight: normal;
        font-size: 16px;
        color: #000000;
        text-align: right;
        font-style: normal;
        text-transform: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        display: inline-flex;
        justify-content: flex-end;

        margin: 0 0 0 10px;
      }

      .ra_status_fail {
        width: 80px;
        font-family: 2, 20;
        font-weight: normal;
        font-size: 16px;
        color: #858585;
        text-align: right;
        font-style: normal;
        text-transform: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        display: inline-flex;
        justify-content: flex-end;

        margin: 0 0 0 10px;
      }
    }
  }
}

/deep/.el-table .el-table__body td {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/deep/.el-table__row .el-table__cell {
  padding: 2px 0 2px 0;
}
/deep/.el-button.is-round {
  margin: 10px 0 10px 0;

}
/deep/.el-button+.el-button {
  margin: 10px 0 10px 10px;
}
</style>